export default __webpack_public_path__ + "static/media/remote group button.38c254ea.svg";